<template>
  <div class="row">
    <div class="col-md-12">
      <div class="main-timeline">
        <div class="timeline" v-for="time in timeLine" :key="time.id">
          <router-link
          
            :to="checkValidation(time.code) == 1 ? { name: time.route } : {}"
            class="timeline-content"
            :class="time.id == 1 ? `avtive` : ``"
            :is="time.id == 1 ? 'span' : 'router-link'"
          >
            <div class="timeline-icon"><i :class="`fa ${time.icon}`"></i></div>
            <h3 class="title">{{ time.title }}</h3>
            <br />
            <ul class="list-style-icons">
              <li v-for="phase in time.phases" :key="phase.code">
                <h4 class="text-white" v-if="checkStatus(phase.code)">
                  <feather-icon icon="CheckIcon" />
                  <del> {{ phase.title }}</del>
                </h4>
                <h4 class="text-white" v-else>
                  <feather-icon icon="XIcon" />
                  {{ phase.title }}
                </h4>
              </li>
            </ul>
          </router-link>
      
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MastersController from "@/Controllers/MastersController";
import MasterKeyStatusController from "@/Controllers/MasterKeyStatusController";

import Auth from "@/Apis/Auth";

export default {
  components: {},
  data() {
    return {
      timeLine: [],
      status: [],
      test: 0,
    };
  },
  async created() {
    console.log(this.checkValidation("plan_structuring_phase"));
    let masterId = Auth.MASTER.id;
    let userId = Auth.USER.id;
    if (this.$route.params.masterId) {
      masterId = this.$route.params.masterId;
      userId = this.$route.params.userId;
    }
    this.status = await new MasterKeyStatusController().GetAll({
      filter: "master_id|" + masterId,
    });
    console.log(this.status);
    this.timeLine = new MastersController().timeLine();
  },
  methods: {
    checkValidation(key) {
      const master_key_inst = new MasterKeyStatusController();
      let res = 0;
    if(key == "approval_of_the_proposal"){
      res =  1;
    } else if(key == "plan_structuring_phase"){
      res =  master_key_inst.verifyStep("department_approval",  Auth.MASTER.id);
     }else if (key == "first_defense"){
      res =  master_key_inst.verifyStep("decision_of_the_department_head",  Auth.MASTER.id);
     }else if(key == "second_defense"){
      res =  master_key_inst.verifyStep("defend_the_plan",  Auth.MASTER.id);
     }else if(key == "thesis"){
      res =  master_key_inst.verifyStep("referral_for_grammar_and_spelling_check",  Auth.MASTER.id);
     }else if(key == "graduation"){
      res =  master_key_inst.verifyStep("edit_search",  Auth.MASTER.id);
     }
      // return res;
      return 1;
    
    },
    checkStatus(key) {
      const find = this.status.filter((a) => a.key == key);
      if (find) {
        let have = false;
        find.forEach((element) => {
          if (element.value >= 1) have = true;
        });
        return have;
      }

      return false;
    },
  },
};
</script>

<style scoped>
.main-timeline {
  font-family: "Poppins", sans-serif;
  padding: 25px 10px;
}
.main-timeline:after {
  content: "";
  display: block;
  clear: both;
}
.main-timeline .timeline {
  width: calc(50% + 9px);
  padding: 20px 30px 20px 0;
  margin: -20px 0 0 0;
  border-radius: 20px;
  border: 10px solid transparent;
  border-right: 10px solid #fff;
  float: left;
  position: relative;
}
.main-timeline .timeline:before,
.main-timeline .timeline:after {
  content: "";
  background-color: #da2677;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  position: absolute;
  right: -18px;
  bottom: 40px;
}
.main-timeline .timeline:after {
  border-radius: 3px;
  transform: rotate(45deg);
  right: 20px;
}
.main-timeline .timeline-content {
  color: #fff;
  background: linear-gradient(#d02578, #da2677);
  min-height: 130px;
  padding: 0 0 20px;

  border-radius: 5px;
  display: block;
  overflow: hidden;
  position: relative;
  z-index: 1;
}
.avtive {
  box-shadow: 0 0 20px rgba(0, 0, 0, 1);
}
.main-timeline .timeline-content:hover {
  text-decoration: none;
}
.main-timeline .timeline-icon {
  font-size: 40px;
  line-height: 40px;
  position: absolute;
  bottom: 15px;
  right: 16px;
}
.main-timeline .title {
  color: #da2677;
  background-color: #fff;
  font-size: 21px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-align: center;
  text-transform: uppercase;
  padding: 12px;
  margin: 0 0 5px;
}
.main-timeline .description {
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 1px;
  line-height: 20px;
  margin: 20px 80px 0 20px;
}
.main-timeline .timeline:nth-child(even) {
  float: right;
  padding: 20px 0 20px 30px;
  margin: -20px 0 0 0;
  border-right: none;
  border-left: 10px solid #fff;
}
.main-timeline .timeline:nth-child(even):before {
  right: auto;
  left: -18px;
}
.main-timeline .timeline:nth-child(even):after {
  right: auto;
  left: 20px;
}
.main-timeline .timeline:nth-child(even) .timeline-icon {
  left: auto;
  right: 16px;
}
.main-timeline .timeline:nth-child(even) .description {
  margin: 20px 20px 0 80px;
}
.main-timeline .timeline:nth-child(4n + 2):before,
.main-timeline .timeline:nth-child(4n + 2):after {
  background-color: #4eb543;
}
.main-timeline .timeline:nth-child(4n + 2) .timeline-content {
  background: linear-gradient(#80b02c, #4eb543);
}
.main-timeline .timeline:nth-child(4n + 2) .title {
  color: #4eb543;
}
.main-timeline .timeline:nth-child(4n + 3):before,
.main-timeline .timeline:nth-child(4n + 3):after {
  background-color: #3a3270;
}
.main-timeline .timeline:nth-child(4n + 3) .timeline-content {
  background: linear-gradient(#65286d, #3a3270);
}
.main-timeline .timeline:nth-child(4n + 3) .title {
  color: #3a3270;
}
.main-timeline .timeline:nth-child(4n + 4):before,
.main-timeline .timeline:nth-child(4n + 4):after {
  background-color: #0a2c80;
}
.main-timeline .timeline:nth-child(4n + 4) .timeline-content {
  background: linear-gradient(#2fd8d8, #0a2c80);
}
.main-timeline .timeline:nth-child(4n + 4) .title {
  color: #0a2c80;
}
@media screen and (max-width: 767px) {
  .main-timeline .timeline,
  .main-timeline .timeline:nth-child(even) {
    width: 100%;
    padding: 20px 0 20px 30px;
    margin: -25px 0 0;
    border-left: 10px solid #fff;
    border-right: none;
  }
  .main-timeline .timeline:before,
  .main-timeline .timeline:nth-child(even):before {
    right: auto;
    left: -17px;
  }
  .main-timeline .timeline:after,
  .main-timeline .timeline:nth-child(even):after {
    right: auto;
    left: 20px;
  }
  .main-timeline .description,
  .main-timeline .timeline:nth-child(even) .description {
    margin: 20px 20px 0 80px;
  }
  .main-timeline .timeline-icon,
  .main-timeline .timeline:nth-child(even) .timeline-icon {
    right: 16px;
    left: auto;
  }
}
@media screen and (max-width: 576px) {
  .main-timeline .timeline-content {
    padding-bottom: 70px;
  }
  .main-timeline .description,
  .main-timeline .timeline:nth-child(even) .description {
    margin: 20px 20px 0 20px;
  }
}
</style>
